import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';

export default ({
    className,
    name,
    value,
    handleDateChange,
    disabled,
    disableFuture = true,
    classes,
    sx,
    ...rest
}) => (
    <DatePicker
        disabled={disabled}
        disableFuture={disableFuture}
        name={name}
        value={value}
        onChange={handleDateChange}
        format="DD/MM/yyyy"
        margin="none"
        OpenPickerButtonProps={{ size: 'small', disableRipple: true }}
        renderInput={params => (
            <TextField
                {...params}
                classes={{ root: className, ...classes }}
                className={className}
                sx={theme => ({
                    '& .MuiOutlinedInput-root': { paddingRight: '14px' },
                    '& .MuiInput-underline:after': {
                        display: 'none',
                    },
                    '& .MuiInput-underline:before': {
                        display: 'none',
                    },
                    '& .MuiInput-input': {
                        padding: 0,
                    },
                    ...(typeof sx === 'function' ? sx(theme) : sx),
                })}
                variant="standard"
                error={false} // override error status
                inputProps={{
                    ...params.inputProps,
                    placeholder: 'JJ/MM/AAAA',
                }}
            />
        )}
        emptyLabel="-"
        {...rest}
    />
);
